const Error404 = () => {
  return <div>This page does not exist.</div>;
};

export default Error404;
